import axios from "axios";
const apiPrefix = '/api/resume-share';

const shareResumeWithUsers = async (resumeId, data) => {
    const response = await axios.post(`${apiPrefix}/${resumeId}/invite`, data);
    return response.data.data;
};

const shareResume = async (resumeId, data) => {
    const response = await axios.post(`${apiPrefix}/${resumeId}`, data);
    
    return response.data.data;
}

const getResumeWithToken = async (token) => {
    const response = await axios.get(`${apiPrefix}`, {
        params: { token }
    })

    return response.data.data;
}

const revokeUserAccess = async (userId) => {
    const response = await axios.delete(`/api/resume-share-user/${userId}`)

    return response.data.data;
}

export default {
    shareResumeWithUsers,
    getResumeWithToken,
    shareResume,
    revokeUserAccess
};
